// Weirdly if you don't use a 'requires' to import the library, it has a different/broken result
// eslint-disable-next-line @typescript-eslint/no-var-requires -- using require instead of import for Crypto library
const CryptoJS = require('crypto-js');

// This function generates the OG Authorization header for a given customer
export const generateOGAuthorization = (
    id: string,
    storefrontApiKey: string | undefined,
    merchantId: string | undefined
) => {
    const ts = Math.floor(new Date().getTime() / 1000);
    const hash = CryptoJS.HmacSHA256(`${id}|${ts}`, storefrontApiKey);
    const sig = CryptoJS.enc.Base64.stringify(hash);
    return JSON.stringify({
        public_id: merchantId,
        sig_field: id,
        ts,
        sig,
    });
};
